import React from 'react';
import { Group, Badge, Text, Stack, Box, Title, ThemeIcon } from '@mantine/core';
import { IconPackage, IconCalendarClock } from '@tabler/icons-react';
import PageTitle from '../common/PageTitle';
import { ShipmentHeaderProps } from './types';
import { formatDate, getStatusBadgeColor } from './utils';

const ShipmentHeader: React.FC<ShipmentHeaderProps> = ({ shipment }) => (
    <>
        {/* Mobile-Optimized Header */}
        <Box display={{ base: 'block', sm: 'none' }}>
            <Stack gap="xs">
                <Group gap="xs" align="center">
                    <ThemeIcon size="lg" radius="md" color="blue" variant="light">
                        <IconPackage size={20} />
                    </ThemeIcon>
                    <Box flex={1}>
                        <Title order={2} size="h3" lineClamp={1}>
                            {`Shipment ID: ${shipment.shipment_id}`}
                        </Title>
                        <Group gap="xs" mt={2}>
                            <IconCalendarClock size={14} style={{ color: 'var(--mantine-color-dimmed)' }} />
                            <Text size="xs" c="dimmed">
                                {formatDate(shipment.createdDate)}
                            </Text>
                        </Group>
                    </Box>
                </Group>

                <Group justify="space-between" align="center" mt="xs">
                    <Badge
                        size="lg"
                        color={getStatusBadgeColor(shipment.status)}
                        variant="filled"
                        style={{ textTransform: 'uppercase', letterSpacing: '0.5px' }}
                    >
                        {shipment.events.length > 0
                            ? shipment.events[0].status
                            : shipment.status.charAt(0).toUpperCase() + shipment.status.slice(1)}
                    </Badge>
                    <Text size="xs" c="dimmed" fw={500}>
                        ID: {shipment.id}
                    </Text>
                </Group>
            </Stack>
        </Box>

        {/* Desktop Header */}
        <Box display={{ base: 'none', sm: 'block' }}>
            <PageTitle
                title={`Shipment ID: ${shipment.shipment_id}`}
                description={`Created on ${formatDate(shipment.createdDate)}`}
                breadcrumbs={[
                    { title: 'Dashboard', href: '/' },
                    { title: 'Shipments', href: '/shipments' },
                    { title: shipment.name }
                ]}
                icon={<IconPackage size={24} />}
                // withBorder
                size="lg"
            >
                <Badge
                    size="xl"
                    color={getStatusBadgeColor(shipment.status)}
                    variant="filled"
                // style={{ textTransform: 'uppercase', letterSpacing: '0.5px' }}
                >
                    {shipment.events.length > 0
                        ? shipment.events[0].status
                        : shipment.status.charAt(0).toUpperCase() + shipment.status.slice(1)}
                </Badge>
                {/* <Text size="sm" c="dimmed" fw={500}>
                        Shipment ID: {shipment.id}
                    </Text> */}
            </PageTitle>
        </Box>
    </>
);

export default ShipmentHeader;
